// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_TOPUP_CRED_BILL, SUC_TOPUP_CRED_BILL } from '../../../../utils/strings';

const useTopUpCredentialBillingLockedDeposit = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_TopUp,
    SUC_TOPUP_CRED_BILL,
    ERR_TOPUP_CRED_BILL,
  );

  return submit;
};

export default useTopUpCredentialBillingLockedDeposit;
